import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback } from 'react';
import { useIntl } from 'react-intl';
import deleteFileIcon from '../../../assets/images/deleteFile.svg';
import { MAX_FILES_SIZE_BYTES, MAX_FILES_SIZE_MEGABYTES } from '../../../common';
import { UploadIcon } from './UploadIcon';
import * as styles from './FileUpload.module.css';
export const FileUpload = ({ files, setFiles, color, hidden = false, }) => {
    const intl = useIntl();
    const [isSizeExceeded, setIsSizeExceeded] = useState(false);
    const getTotalFileSize = useCallback(() => {
        return files.reduce((totalSize, file) => totalSize + file.size, 0);
    }, [files]);
    const onUploadFiles = (files) => {
        if (!files)
            return;
        const validFiles = [];
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const fileInfo = { name: file.name, size: file.size, file };
            validFiles.push(fileInfo);
        }
        const totalSize = getTotalFileSize() + validFiles.reduce((totalSize, file) => totalSize + file.size, 0);
        setIsSizeExceeded(totalSize > MAX_FILES_SIZE_BYTES);
        if (totalSize <= MAX_FILES_SIZE_BYTES)
            setFiles((prevFiles) => [...prevFiles, ...validFiles]);
    };
    const handleFileRemove = (nameToRemove) => setFiles(files.filter(({ name }) => name !== nameToRemove));
    const handleFileDrop = (e, files) => {
        e.preventDefault();
        e.stopPropagation();
        files && onUploadFiles(files);
    };
    return (_jsxs("div", { hidden: hidden, children: [files.map(({ name }) => (_jsxs("div", { className: styles.fileItem, children: [_jsx("span", { className: styles.fileName, children: name }), _jsx("button", { className: styles.removeButton, onClick: () => handleFileRemove(name), children: _jsx("img", { src: deleteFileIcon, alt: 'delete', draggable: false }) })] }, name))), _jsx("div", { className: `${styles.uploadBox} ${isSizeExceeded ? styles.sizeExceeded : ''}`, style: { border: `1px dashed ${color}` }, onDrop: (e) => handleFileDrop(e, e.dataTransfer.files), onDragOver: handleFileDrop, children: _jsxs("label", { htmlFor: 'file-upload', children: [_jsx("input", { hidden: true, type: 'file', id: 'file-upload', multiple: true, onChange: (e) => onUploadFiles(e.target.files) }), _jsx(UploadIcon, { color: color }), _jsx("span", { style: { color }, children: intl.formatMessage({ id: 'selectFiles' }) }), intl.formatMessage({ id: 'orDropFiles' })] }) }), isSizeExceeded && (_jsx("p", { className: styles.sizeExceededText, children: intl.formatMessage({ id: 'maxFileSizeError' }, { maxSize: MAX_FILES_SIZE_MEGABYTES }) }))] }));
};
